import { useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { trackEvents } from "../amplitude";

const SEARCH_DEBOUNCE_MS = 800;

export const getLeadSearchType = (
  _query: string,
  leads?: { name?: string | null; lead_id?: string }[]
): "lead" | "anon_lead" => {
  if (
    leads?.length &&
    leads.some(
      (lead) => lead.name && lead.lead_id && /^\d{8,}$/.test(lead.lead_id)
    )
  )
    return "lead";

  return "anon_lead";
};

export const useSearchTracking = (moduleName: string) => {
  const orgId =
    useSelector((state: RootState) => state?.auth?.client?.client_code) ||
    "unknown";
  const userId =
    useSelector((state: RootState) => state?.auth?.user?._id) || "unknown";
  const lastTrackedRef = useRef<{ query: string; time: number }>({
    query: "",
    time: 0,
  });

  const trackSearchPerformed = useCallback(
    (params: {
      search_value: string;
      search_type?: string;
      result_count?: number;
    }) => {
      const now = Date.now();
      const trimmed = params.search_value?.trim();
      if (!trimmed) return;

      if (
        lastTrackedRef.current.query === trimmed &&
        now - lastTrackedRef.current.time < SEARCH_DEBOUNCE_MS
      ) {
        return;
      }

      lastTrackedRef.current = { query: trimmed, time: now };

      trackEvents("search_performed", {
        search_value: trimmed,
        module_name: moduleName,
        search_type: params.search_type || "text",
        ...(params.result_count !== undefined && {
          result_count: params.result_count,
        }),
        user_id: userId,
        org_id: orgId,
      });
    },
    [moduleName, userId, orgId]
  );

  return { trackSearchPerformed };
};
